<template>
  <DialogHeader>
    <template #right>
      <div
        v-if="!loading"
        class="font-medium text-green-900 cursor-pointer"
        @click="handleSend"
      >
        Send
      </div>
      <Icon
        v-else
        name="Loading"
        :size="14"
        class="stroke-gray-800 animate-spin"
      />
    </template>
    Report an issue
  </DialogHeader>
  <DialogContent>
    <div class="font-secondary text-[14px] leading-[22px] mb-5">
      Please report any issues or feedback you experienced with your report
    </div>
    <UiTextarea
      v-model="message"
      label="Your feedback"
      placeholder="Your feedback"
    />
  </DialogContent>
  <DialogFooter>
    <UiButton class="w-full" primary :loading="loading" @click="handleSend">
      Send
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { Icon, UiButton, UiTextarea } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { ref } from 'vue'

const { close, triggerEvent } = useDialog()

const message = ref('')
const loading = ref(false)

const handleSend = () => {
  triggerEvent('success', message.value)
  close()
}
</script>
